import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportQuotationRequest } from './Quotation.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportQuotation(
  params: QuestReportQuotationRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/Quotation`,
    params,
  )) as unknown;

  return result as BlobPart;
}
